<template>
  <!--<div v-if="isLoading" class="loading-overlay">
    <LoadingModal message="Caricamento in corso..." />
  </div>-->
  <div v-show="isLoading">
    <LoadingOverlay :show="isLoading" title="Caricamento quesiti" :message="loadingMessage" />
  </div>  
  <SimpleModal v-model="showLandingModal" title="" :buttons="['OK']" @chose="() => {
    this.showLandingModal = false;
    this.$router.push({ name: 'questions.list', query: { t: Date.now() } });
  }">
    <p>Segnalazione inviata con successo</p>
  </SimpleModal>
  <div class="it-accordion-wrapper it-accordion">
    <!-- Titolo più piccolo -->
    <h3 class="mb-4">Consultazione pareri relativi al D.lgs. 50/2016</h3>
    <div id="searchbox" class="card-body bg-white shadow rounded m-3 mb-5">
      <div class="px-4">
        <div class="mb-2 d-flex justify-content-end w-100">
          <div class="form-group mb-0 mt-3 me-3" style="width: 250px;">
            <label for="text-search" class="active">Filtra contenuto parere:</label>
            <input v-model="searchInput" @keyup.enter="handleSearch" type="text" class="form-control mb-3"
              id="text-search" placeholder="Ricerca per contenuti" />
            <Transition>
              <a v-if="searchInput !== ''" class="cpointer" @click="clearSearch">
                <svg class="icon icon-sm icon-primary">
                  <use :href="$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-funnel'" />
                </svg>
                Ripristina filtro contenuto
              </a>
            </Transition>
          </div>
          <div class="d-flex">
            <!--<button type="button" :disabled="searchInput === ''" @click="handleSearch"-->
            <button type="button" @click="handleSearch"
              class="my-auto btn btn-primary p-3 ms-4 shadow rounded-circle btn-lg">
              <svg class="icon icon icon-white">
                <use :href="$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-search'" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- Accordion topics -->
    <transition-group name="collapse" tag="div" class="accordion-list">
      <div class="accordion-list" v-if="groupedTopics.length">
        <div class="accordion-item" v-for="topic in groupedTopics" :key="topic.topic_id">
          <!-- Topic Header con freccia SVG -->
          <div class="accordion-header d-flex align-items-center" style="cursor: pointer;"
            @click="toggleTopic(topic.topic_id)">
            <svg class="icon me-2" width="16" height="16">
              <use :href="openedTopics.includes(topic.topic_id)
                ? '/bootstrap-italia/dist/svg/sprites.svg#it-collapse'
                : '/bootstrap-italia/dist/svg/sprites.svg#it-expand'" />
            </svg>
            <strong class="ms-2">{{ topic.topic_title.toUpperCase() }}</strong>
          </div>

          <!-- Topic Body -->
          <transition name="collapse">
            <div v-if="openedTopics.includes(topic.topic_id)">
              <div class="accordion-body">
                <div class="mb-2 border-bottom pb-2" v-for="q in topic.questions" :key="q.question_id">
                  <!-- Parere Header -->
                  <div class="d-flex align-items-center" style="cursor: pointer;"
                    @click="toggleParere(topic.topic_id, q.question_id)">
                    <svg class="icon me-2" width="16" height="16">
                      <use :href="openedPareri[topic.topic_id]?.includes(q.question_id)
                        ? '/bootstrap-italia/dist/svg/sprites.svg#it-collapse'
                        : '/bootstrap-italia/dist/svg/sprites.svg#it-expand'" />
                    </svg>
                    <strong class="ms-2">{{ q.parere_title }}</strong>
                  </div>

                  <!-- Parere Content -->
                  <transition name="collapse">
                    <div v-if="openedPareri[topic.topic_id]?.includes(q.question_id)" class="mt-2">
                      <p><strong class="parere-label">Oggetto:</strong> {{ q.object }}</p>
                      <p><strong class="parere-label">Quesito:</strong> {{ q.text }}</p>
                      <p><strong class="parere-label">Risposta Aggiornata:</strong> {{ q.answer }}</p>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition-group>

    <!-- Paginazione -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="pagination">
      <div class="text-muted">
        Mostrando {{ (pagination.currentPage - 1) * pagination.perPage + 1 }} -
        {{ Math.min(pagination.currentPage * pagination.perPage, pagination.total) }}
        di {{ pagination.total }} elementi
      </div>
      <!-- <nav aria-label="Page navigation">
            <ul class="pagination mb-0">

              <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.currentPage - 1)">
                  <i class="bi bi-chevron-left"></i>
                </a>
              </li>
              
              <li v-if="pagination.currentPage > 3" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(1)">1</a>
              </li>
              
              <li v-if="pagination.currentPage > 4" class="page-item disabled">
                <span class="page-link">...</span>
              </li>

              <li v-for="page in visiblePageNumbers" :key="page" class="page-item" :class="{ active: page === Number(pagination.currentPage) }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
              </li>
              

              <li v-if="pagination.currentPage < pagination.lastPage - 3" class="page-item disabled">
                <span class="page-link">...</span>
              </li>
              
              <li v-if="pagination.currentPage < pagination.lastPage - 2" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.lastPage)">{{ pagination.lastPage }}</a>
              </li>
              
              <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.lastPage }">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.currentPage + 1)">
                  <i class="bi bi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>-->
      <nav aria-label="Page navigation">
        <ul class="pagination mb-0">
          <!-- Pulsante pagina precedente -->
          <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
            <button class="page-link" :disabled="pagination.currentPage === 1"
              @click="changePage(pagination.currentPage - 1)">
              <i class="bi bi-chevron-left"></i>
            </button>
          </li>

          <!-- Prima pagina -->
          <li v-if="pagination.currentPage > 3" class="page-item">
            <button class="page-link" @click="changePage(1)">1</button>
          </li>

          <!-- Ellipsis se necessario -->
          <li v-if="pagination.currentPage > 4" class="page-item disabled">
            <span class="page-link">...</span>
          </li>

          <!-- Pagine attorno alla pagina corrente -->
          <li v-for="page in visiblePageNumbers" :key="page" class="page-item"
            :class="{ active: page === Number(pagination.currentPage) }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>

          <!-- Ellipsis se necessario -->
          <li v-if="pagination.currentPage < pagination.lastPage - 3" class="page-item disabled">
            <span class="page-link">...</span>
          </li>

          <!-- Ultima pagina -->
          <li v-if="pagination.currentPage < pagination.lastPage - 2" class="page-item">
            <button class="page-link" @click="changePage(pagination.lastPage)">{{ pagination.lastPage }}</button>
          </li>

          <!-- Pulsante pagina successiva -->
          <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.lastPage }">
            <button class="page-link" :disabled="pagination.currentPage === pagination.lastPage"
              @click="changePage(pagination.currentPage + 1)">
              <i class="bi bi-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>

    </div>

    <!-- sezione con la domanda-->
    <div v-if="$root.user" class="footer-question" ref="footerQuestion">
      <div class="popup-box p-4 text-center fade-in">

        <p class="fw-bold mb-3" style="font-size: 1.1rem;">
          Hai trovato la risposta alla tua domanda?
        </p>

        <div class="d-flex justify-content-center align-items-center gap-4 mb-3">
          <label class="form-check-label d-flex align-items-center gap-2">
            <input type="radio" value="yes" v-model="footerAnswer" name="foundRadio" />
            Sì
          </label>

          <label class="form-check-label d-flex align-items-center gap-2">
            <input type="radio" value="no" v-model="footerAnswer" name="foundRadio" />
            No, voglio inviare un quesito
          </label>
        </div>

        <button class="btn btn-primary btn-sm mt-2" :disabled="!footerAnswer" @click="handleFooterChoice">
          Invia
        </button>

      </div>
    </div>

  </div>
</template>

<script>
import LoadingModal from '../../partials/LoadingModal.vue';
import SimpleModal from '../../../components/common/SimpleModal.vue';
import LoadingOverlay from '../../partials/LoadingOverlay.vue';

export default {
  name: "QuestionsByTopicView",
  components: {
    LoadingModal,
    SimpleModal,
    LoadingOverlay
  },
  data() {
    return {
      groupedTopics: [],
      openedTopics: [],
      openedPareri: {},
      search: '',
      pagination: {
        currentPage: 1,
        perPage: 10,
        total: 0,
        lastPage: 1,
      },
      footerAnswer: null,
      searchInput: '',
      isLoading: true,
      showLandingModal: false,
    };
  },
  computed: {

    visiblePageNumbers() {
      if (!this.pagination) return [];

      const currentPage = this.pagination.currentPage;
      const lastPage = this.pagination.lastPage;
      const delta = 2; // Numero di pagine da mostrare prima e dopo la pagina corrente

      let start = Math.max(1, currentPage - delta);
      let end = Math.min(lastPage, currentPage + delta);

      // Assicuriamoci di mostrare sempre 2*delta+1 pagine se possibile
      if (end - start < 2 * delta) {
        if (start === 1) {
          end = Math.min(start + 2 * delta, lastPage);
        } else if (end === lastPage) {
          start = Math.max(end - 2 * delta, 1);
        }
      }

      // Genera l'array di numeri di pagina da mostrare
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  async mounted() {
    await this.loadQuestions(1);
  },
  methods: {
    handleSearch() {
      this.loadQuestions(1);
    },
    clearSearch() {
      this.searchInput = '';
      this.loadQuestions(1);
    },
    async handleFooterChoice() {
      if (this.footerAnswer === "no") {
        const selectedArticleId = this.localArticle?.id || null;
        const selectedVersionId = this.localArticle?.activeVersion?.version?.id || null;
        const activeVersionId = this.localArticle?.activeVersion?.id || null;
        this.$router.push({
          name: "questions.new",
          query: { article: selectedArticleId, version: selectedVersionId, activeVersionId: activeVersionId }
        });
      }

      else {
        try {
          const token = localStorage.getItem('token');
          const url = new URL(`${this.$root.config.VITE_APP_BACKOFFICE_URL}/user-feedback`);

          const payload = {
            legislation_id: null,
            user_id: this.$root.user?.sub
          };

          const response = await fetch(url.toString(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token ? `Bearer ${token}` : ''
            },
            //credentials: 'include',
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error('Errore nell’invio della segnalazione');
          }

          this.showLandingModal = true;

        } catch (error) {
          console.error(error);
          alert('Si è verificato un errore, riprova.');
        }
      }
    },
    async changePage(page) {
      if (page < 1 || page > this.pagination.lastPage) return;
      const scrollPos = window.scrollY;
      await this.loadQuestions(page);
      window.scrollTo({ top: 0, behavior: 'auto' });
    },
    async loadQuestions(page = 1) {
      this.isLoading = true;
      const params = { page, per_page: this.pagination.perPage, search: this.searchInput || undefined };
      const res = await this.$root.$api.get('/questions-by-topic', { params });

      this.groupedTopics = res.data.data || [];
      this.pagination = {
        currentPage: res.data.current_page || 1,
        perPage: res.data.per_page || 5,
        total: res.data.total || 0,
        lastPage: res.data.last_page || 1,
      };

      // Apri tutti i topic e pareri di default
      this.openedTopics = this.groupedTopics.map(t => t.topic_id);
      this.openedPareri = {};
      this.groupedTopics.forEach(t => {
        this.openedPareri[t.topic_id] = t.questions.map(q => q.question_id);
      });
      this.isLoading = false;
    },
    toggleTopic(id) {
      const idx = this.openedTopics.indexOf(id);
      if (idx >= 0) this.openedTopics.splice(idx, 1);
      else this.openedTopics.push(id);
    },
    toggleParere(topicId, questionId) {
      if (!this.openedPareri[topicId]) this.openedPareri[topicId] = [];
      const idx = this.openedPareri[topicId].indexOf(questionId);
      if (idx >= 0) this.openedPareri[topicId].splice(idx, 1);
      else this.openedPareri[topicId].push(questionId);
    }
  }
};
</script>

<style scoped>
.ms-2 {
  margin-left: 0.5rem;
}

.icon {
  fill: currentColor;
  transition: transform 0.3s ease;
}

.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease;
}

.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.collapse-enter-to,
.collapse-leave-from {
  max-height: 500px;
  opacity: 1;
}

.parere-label {
  color: blue;
}

/* Paginazione */
.pagination {
  margin-bottom: 0;
}

.pagination .page-item.active .page-link {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary);
  box-shadow: 0 2px 5px rgba(var(--bs-primary-rgb), 0.2);
  color: var(--bs-white);
}


.pagination .page-link {
  border-radius: 0.25rem;
  margin: 0 0.125rem;
  color: var(--bs-primary);
  border: 1px solid var(--bs-border-color);
  background-color: var(--bs-body-bg);
}

.pagination .page-link:hover {
  background-color: var(--bs-tertiary-bg);
  border-color: var(--bs-border-color);
}

.footer-question {
  margin-top: 2rem;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  padding: 2rem 0;
}

.popup-box {
  background: white;
  border-radius: 12px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: auto;
}

.fade-in {
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cpointer {
  cursor: pointer;
}

#searchbox {
  position: sticky;
  top: 0.1875rem;
  z-index: 1000;

  max-width: 25rem !important;
  margin-left: auto !important;
}

@media (max-width: 992px) {
  #searchbox {
    position: static;
    max-width: 100%;
    margin-left: 0;
  }
}

.loading-overlay {
  position: fixed;
  /* Copre tutta la finestra */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-trasparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  /* Deve essere sopra tutto */
  overflow: hidden;
  /* Previene scroll */
}


.loading-overlay>* {
  animation: fadeIn 0.2s ease-in-out;
  /* optional fade-in del modal */
}
</style>
